const getInstitutionDescription = (institution, index) => {
  const group1 = [
    "{name} is a distinguished institution recognized for its contributions to {keywords}. With {citation_count} citations and {publication_count} publications, it plays a pivotal role in advancing research and knowledge in the field.",
    "As a leading institution in {keywords}, {name} has significantly impacted research with {publication_count} publications and {citation_count} citations. Its contributions continue to shape the academic landscape.",
    "{name} stands out for its excellence in {keywords}, demonstrated by {publication_count} publications and {citation_count} citations. Its research has influenced both academic and practical advancements.",
    "With an impressive {citation_count} citations across {publication_count} publications, {name} has established itself as a highly cited institution in {keywords}, driving impactful research and discoveries.",
  ];

  const group2 = [
    "Renowned for its pioneering work in {keywords}, {name} has contributed {publication_count} publications, earning {citation_count} citations. It remains at the forefront of innovation and academic excellence.",
    "{name} has significantly influenced the domain of {keywords}, producing {publication_count} publications with {citation_count} citations. Its scholarly work continues to inspire future research.",
    "A global leader in {keywords}, {name} has amassed {publication_count} publications and {citation_count} citations. Its research output reflects its commitment to academic progress and innovation.",
    "{name} is a key contributor to {keywords}, with {publication_count} publications and {citation_count} citations. Its academic contributions have shaped the discourse and development in the field.",
  ];

  const getRes = (str, institution) => {
    const res = str
      .replaceAll("{name}", institution?.name || "?")
      .replaceAll(
        "{keywords}",
        institution.keywords
          .map((e) => e.value)
          .slice(0, 3)
          .join(", ") || "?"
      )
      .replaceAll(
        "{publication_count}",
        institution?.specific_stats.publication_count || "?"
      )
      .replaceAll(
        "{citation_count}",
        institution?.specific_stats.citation_count || "?"
      );
    return res;
  };

  return getRes(
    index % 2 === 0
      ? group1[Math.floor(Math.random() * group1.length)]
      : group2[Math.floor(Math.random() * group2.length)],
    institution
  );
};

export default getInstitutionDescription;
